import { Button, Input, onEnter, useTheme } from '@ytl/common-web';
import { useCallback, useEffect, useState } from 'react';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';
import { LoginAnalytics } from '../shared/utils/analytics';

export const DeviceCodeStage = () => {
  const { translation } = useLanguage();
  const { isLoading } = useOpenAm();
  const [deviceCode, setDeviceCode] = useState('');

  const [error, setError] = useState('');

  const { isWebView } = useTheme();
  const codeLength = 8;

  const sendDeviceCode = useCallback(async () => {
    try {
      // Create a hidden form element
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = window.location.pathname;
      form.style.display = 'none';

      // Add the device code input field
      const input = document.createElement('input');
      input.type = 'text';
      input.name = 'user_code';
      input.value = deviceCode;
      form.appendChild(input);

      // Append form to body, submit it, and remove it
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (err) {
      LoginAnalytics.loginError(isWebView, 'devicecode', false, 'error-devicecode-send-error');
      setError(translation.loginRegister.login.device.senderror);
    }
  }, [deviceCode, setError, translation, isWebView]);

  useEffect(() => {
    // @ts-ignore
    const deviceCodeError = window['__deviceCodeError'];

    if (typeof deviceCodeError === 'string' && deviceCodeError.length > 0 && !deviceCodeError.startsWith('<#if')) {
      LoginAnalytics.loginError(isWebView, 'devicecode', false, 'error-devicecode-invalid-code');
      setError(translation.loginRegister.login.device.codenotfound);
    }
  }, [setError, translation, isWebView]);

  useEffect(() => {
    const userCode = new URLSearchParams(window.location.search).has('user_code');
    if (userCode) {
    }
  }, []);

  return (
    <>
      <h3>{translation.loginRegister.login.device.title}</h3>
      <div className={'login-page__device-code-content'}>{translation.loginRegister.login.device.content}</div>

      <div className={'login-page__device-code-input-container'}>
        <Input
          label={<div>{translation.loginRegister.login.device.fieldlabel}</div>}
          name={'devicecode'}
          type={'text'}
          value={deviceCode}
          onChange={e => {
            setDeviceCode(e.target.value);
            setError('');
          }}
          disabled={isLoading}
          maxLength={codeLength}
          onKeyUp={onEnter(sendDeviceCode)}
        />
      </div>

      {error && <div className="login-page__container__error">{error}</div>}

      <Button
        variant={'contained'}
        onClick={sendDeviceCode}
        disabled={isLoading || deviceCode.length < codeLength}
      >
        {translation.loginRegister.login.device.button}
      </Button>
    </>
  );
};
